import { getField } from 'vuex-map-fields';

export default {
  getField,
  hasGeneratedItems (state, { itemsCount }) {
    return itemsCount > 0;
  },
  itemsCount ({ generatedItems }) {
    return Object.keys(generatedItems).length;
  }
}